import supabase from './database';

// Singleton auth client derived from the existing Supabase client.
const authClient = supabase.auth;

// Firebase-like getter to ease migration of existing code.
export const getAuth = () => authClient;

// Firebase-style listener: onAuthStateChanged(auth, callback) -> unsubscribe()
export const onAuthStateChanged = (_auth, callback) => {
  const { data, error } = authClient.onAuthStateChange((_event, session) => {
    callback(session?.user ?? null);
  });

  if (error) {
    throw error;
  }

  const subscription = data?.subscription;
  return () => subscription?.unsubscribe();
};

// Firebase-style sign in with email/password.
export const signInWithEmailAndPassword = async (_auth, email, password) => {
  const { data, error } = await authClient.signInWithPassword({ email, password });
  if (error) throw error;
  return data;
};

// Firebase-style sign out.
export const signOut = async (_auth) => {
  const { error } = await authClient.signOut();
  if (error) throw error;
};

// Helper to fetch the current user (instead of auth.currentUser).
export const getCurrentUser = async () => {
  const { data, error } = await authClient.getUser();
  if (error) throw error;
  return data?.user ?? null;
};

export const getSession = async () => {
  const { data, error } = await authClient.getSession();
  if (error) throw error;
  return data.session ?? null;
};

export default {
  auth: authClient,
  getAuth,
  onAuthStateChanged,
  signInWithEmailAndPassword,
  signOut,
  getCurrentUser,
  getSession,
};
